import { API_ROUTES } from "../utils/constants"
import apiHelper from "./apiHelper"

export function createRankSystem(data) {
    return apiHelper({ method: "post", path: API_ROUTES.RANKSYSTEM.CREATE, data })
}
export function connect({ botId }) {
    return apiHelper({ method: "post", path: API_ROUTES.RANKSYSTEM.CONNECT, data: { botId } })
}

export function connectBulk({ botId }) {
    return apiHelper({ method: "post", path: API_ROUTES.RANKSYSTEM.CONNECT_BULK, data: { botId } })
}

export function disconnect({ botId }) {
    return apiHelper({ method: "post", path: API_ROUTES.RANKSYSTEM.DISCONNECT, data: { botId } })
}

export function disconnectBulk({ botId }) {
    return apiHelper({ method: "post", path: API_ROUTES.RANKSYSTEM.DISCONNECT_BULK, data: { botId } })
}

export function activate({ botId }) {
    return apiHelper({ method: "post", path: API_ROUTES.RANKSYSTEM.ACTIVATE, data: { botId } })
}

export function suspend({ botId }) {
    return apiHelper({ method: "post", path: API_ROUTES.RANKSYSTEM.SUSPEND, data: { botId } })
}

export function reconnect({ botId }) {
    return apiHelper({ method: "post", path: API_ROUTES.RANKSYSTEM.RECONNECT, data: { botId } })
}

export function reconnectBulk({ botId }) {
    return apiHelper({ method: "post", path: API_ROUTES.RANKSYSTEM.RECONNECT_BULK, data: { botId } })
}

export function extend({ botId }) {
    return apiHelper({ method: "post", path: API_ROUTES.RANKSYSTEM.EXTEND, data: { botId } })
}
export function editRankSystem(data) {
    return apiHelper({ method: "post", path: API_ROUTES.RANKSYSTEM.EDIT, data })
}

export function deleteRankSystem({ botId }) {
    return apiHelper({ method: "delete", path: API_ROUTES.RANKSYSTEM.DELETE, data: { botId } })
}

export function updateRankSystemSettings(data) {
    return apiHelper({ method: "post", path: API_ROUTES.RANKSYSTEM.UPDATE_SETTINGS, data })
}

export function getRankSystemSettings() {
    return apiHelper({ method: "get", path: `${API_ROUTES.RANKSYSTEM.GET_SETTINGS}` })
}
